import {
  GraduateCourseCreate,
  GraduateCourseEdit,
  GraduateCourseList,
  GraduateCourseShow
} from 'pages/graduate_courses';
import { generateResources } from 'utils/GenerateResouces';

const resource = {
  name: 'graduate_courses',
  label: 'Cursos regulados',
  list: GraduateCourseList,
  show: GraduateCourseShow,
  edit: GraduateCourseEdit,
  create: GraduateCourseCreate,
  actions: ['list', 'show', 'edit', 'create', 'delete'],
  parentName: 'course_creation'
};

export default generateResources(resource);
